// extracted by mini-css-extract-plugin
export var container = "_77-0";
export var error = "_77-9";
export var label = "_77-5";
export var light = "_77-6";
export var md = "_77-3";
export var sm = "_77-2";
export var thin = "_77-8";
export var thinBold = "_77-7";
export var vertical = "_77-4";
export var xs = "_77-1";